var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquarePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_680_1315)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9C12.75 9.41475 12.414 9.75 12 9.75H9.75V12C9.75 12.4148 9.414 12.75 9 12.75C8.586 12.75 8.25 12.4148 8.25 12V9.75H6C5.586 9.75 5.25 9.41475 5.25 9C5.25 8.58525 5.586 8.25 6 8.25H8.25V6C8.25 5.58525 8.586 5.25 9 5.25C9.414 5.25 9.75 5.58525 9.75 6V8.25H12C12.414 8.25 12.75 8.58525 12.75 9ZM18 3.75V14.25C18 16.3177 16.3177 18 14.25 18H3.75C1.68225 18 0 16.3177 0 14.25V3.75C0 1.68225 1.68225 0 3.75 0H14.25C16.3177 0 18 1.68225 18 3.75ZM16.5 3.75C16.5 2.5095 15.4905 1.5 14.25 1.5H3.75C2.5095 1.5 1.5 2.5095 1.5 3.75V14.25C1.5 15.4905 2.5095 16.5 3.75 16.5H14.25C15.4905 16.5 16.5 15.4905 16.5 14.25V3.75Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_680_1315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarePlus);
export default __webpack_public_path__ + "static/media/SquarePlus.0e17422ada52fed0ab14d44ce9004975.svg";
export { ForwardRef as ReactComponent };